import {
  Activity,
  BrainCircuit,
  ClipboardCheck,
  Command,
  FileCode2,
  FileStack,
  GalleryVerticalEnd,
  HeartPulse,
  MessageSquareText,
  RadioTower,
  RotateCcw,
  Sparkles,
  Stethoscope,
  Users,
  type LucideIcon,
} from "lucide-react";

export type AppModule = {
  id: string;
  title: string;
  description: string;
  href: string;
  group: "ai" | "content" | "operations" | "system";
  icon: LucideIcon;
};

export const modules: AppModule[] = [
  {
    id: "maia-ticket-search",
    title: "Поиск по тикетам",
    description: "Переписка HDE, фильтры и смысловой поиск",
    href: "/modules/maia-ticket-search",
    group: "operations",
    icon: MessageSquareText,
  },
  {
    id: "widgets",
    title: "Виджеты и loader",
    description: "JavaScript, публикации и история версий",
    href: "/modules/widgets",
    group: "content",
    icon: FileCode2,
  },
  {
    id: "maia",
    title: "MAIA",
    description: "Модели, HDE, RAG, интеграции и аналитика",
    href: "/modules/maia",
    group: "ai",
    icon: Sparkles,
  },
  {
    id: "maia-chat",
    title: "Внутренний чат",
    description: "Рабочие диалоги с MAIA",
    href: "/chat",
    group: "ai",
    icon: MessageSquareText,
  },
  {
    id: "transcription-analysis",
    title: "Встречи с MAIA",
    description: "Записи, стенограммы и итоги встреч",
    href: "/modules/transcription-analysis",
    group: "ai",
    icon: RadioTower,
  },
  {
    id: "maia-imports",
    title: "Импорты с MAIA",
    description: "Импорты клиентов и услуг и их откат",
    href: "/modules/maia-imports",
    group: "ai",
    icon: RotateCcw,
  },
  {
    id: "klientiks-telemed",
    title: "Видеоконсультации",
    description: "Настройки и контроль медицинских консультаций",
    href: "/modules/klientiks-telemed",
    group: "ai",
    icon: Stethoscope,
  },
  {
    id: "llm-gateway",
    title: "Клиенты API",
    description: "Доступ сторонних сервисов к моделям",
    href: "/modules/llm-gateway",
    group: "ai",
    icon: BrainCircuit,
  },
  {
    id: "clinical-recommendations",
    title: "Клинические рекомендации",
    description: "Рекомендации, лечения и массовый импорт",
    href: "/modules/clinical-recommendations",
    group: "content",
    icon: HeartPulse,
  },
  {
    id: "media-library",
    title: "Медиатека",
    description: "Управление изображениями и видео",
    href: "/modules/media-library",
    group: "content",
    icon: GalleryVerticalEnd,
  },
  {
    id: "docx-converter",
    title: "Конвертер DOCX",
    description: "Подготовка HTML из документов",
    href: "/modules/docx-converter",
    group: "content",
    icon: FileStack,
  },
  {
    id: "html-handler",
    title: "Обработчик HTML",
    description: "Очистка и преобразование шаблонов",
    href: "/modules/html-handler",
    group: "content",
    icon: FileCode2,
  },
  {
    id: "validator-semd",
    title: "Валидатор СЭМД",
    description: "Схемы, диагностика и аналитика",
    href: "/modules/validator-semd",
    group: "operations",
    icon: ClipboardCheck,
  },
  {
    id: "cmdlab",
    title: "CMD Lab",
    description: "Интеграции CMD и операторы",
    href: "/modules/cmdlab",
    group: "operations",
    icon: Command,
  },
  {
    id: "monitoring",
    title: "Мониторинг",
    description: "Состояние серверов и инфраструктуры",
    href: "https://monitoring.klientiks.ru",
    group: "operations",
    icon: Activity,
  },
  {
    id: "users",
    title: "Пользователи",
    description: "Учётные записи, роли и права",
    href: "/users",
    group: "system",
    icon: Users,
  },
];

export const groupLabels = {
  ai: "Искусственный интеллект",
  content: "Контент и документы",
  operations: "Операции",
  system: "Система",
} as const;
